import PosterCard from './card';

export { PosterCard };
